import type { AxiosRequestConfig, AxiosResponse } from "axios";
import { axiosPost } from "./axiosForRails";
import { convertKeysToSnakeCase } from "./convertKeysToSnakeCase";

export const axiosPostCamelToSnake = {
  post: <T = unknown>(
    url: string,
    data: Record<string, unknown>,
    config: AxiosRequestConfig<unknown> = {},
  ): Promise<AxiosResponse<T>> => {
    const snakeCaseData = convertKeysToSnakeCase(data) as Record<string, unknown>;
    return axiosPost.post<T>(url, snakeCaseData, config);
  },

  // 添付ファイルがある場合のPOST
  // NOTE: axiosPost.postでは multipart/form-data のヘッダーが自動で設定される
  postWithFiles: <T = unknown>(
    url: string,
    data: Record<string, unknown>,
    config: AxiosRequestConfig<unknown> = {},
  ): Promise<AxiosResponse<T>> => {
    const formData = new FormData();
    appendToFormData(formData, data);

    return axiosPost.post<T>(url, formData, {
      ...config,
      headers: {
        ...config.headers,
      },
    });
  },
};

// postWithFilesのFormDataにデータを追加するヘルパー関数
function appendToFormData(formData: FormData, data: Record<string, unknown>, prefix = ""): void {
  Object.entries(data).forEach(([key, value]) => {
    const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
    const formKey = prefix ? `${prefix}[${snakeKey}]` : snakeKey;

    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item instanceof File) {
          formData.append(`${formKey}[]`, item);
        } else if (typeof item === "object" && item !== null) {
          appendToFormData(formData, item as Record<string, unknown>, `${formKey}[]`);
        } else {
          formData.append(`${formKey}[]`, String(item));
        }
      });
    } else if (value instanceof File) {
      formData.append(formKey, value);
    } else if (typeof value === "object" && value !== null) {
      appendToFormData(formData, value as Record<string, unknown>, formKey);
    } else if (value !== undefined && value !== null) {
      // eslint-disable-next-line @typescript-eslint/no-base-to-string -- File/オブジェクト除外後のためプリミティブのみ到達する（型上は unknown のため検知される）
      formData.append(formKey, String(value));
    }
  });
}
